<template>
  <v-container id="vendor-add" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-form v-model="isValid" ref="form">
          <v-card>
            <v-toolbar color="white" fixed>
              <h3>{{ $i18n.t(label) }}</h3>
            </v-toolbar>
            <v-card-text>
              <v-container dense>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="corporate.name"
                      :label="$i18n.t('Short Name') + '*'"
                      :rules="validationrules.name"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      v-model="corporate.fullName"
                      :label="$i18n.t('Full Name') + '*'"
                      :rules="validationrules.fullName"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <h4>Address</h4>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="3" md="2" lg="2">
                    <z-country-select
                      required
                      v-model="corporate.address.country"
                      :rules="validationrules.addressCountry"
                    ></z-country-select>
                  </v-col>
                  <v-col cols="12" sm="3" md="2" lg="3">
                    <z-state-select
                      required
                      v-model="corporate.address.state"
                      :country="corporate.address.country"
                      :rules="validationrules.addressState"
                    ></z-state-select>
                  </v-col>
                  <v-col cols="12" sm="3" md="2" lg="3">
                    <z-city-select
                      required
                      v-model="corporate.address.city"
                      :country="corporate.address.country"
                      :rules="validationrules.addressCity"
                    ></z-city-select>
                  </v-col>
                  <v-col cols="12" sm="3" md="2" lg="4">
                    <v-text-field
                      :label="$i18n.t('Address')"
                      required
                      v-model="corporate.address.addressLine"
                      :rules="validationrules.addressAddressLine"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <h4>Organization Information</h4>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :label="$i18n.t('PAN')"
                      required
                      v-model="corporate.PANNo"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :label="$i18n.t('GSTIN')"
                      required
                      v-model="corporate.GSTNo"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :label="$i18n.t('TAN No')"
                      required
                      v-model="corporate.TANNo"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :label="$i18n.t('CIN')"
                      required
                      v-model="corporate.CINno"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row v-if="false">
                  <h4>Admin Details</h4>
                </v-row>

                <v-row v-if="false">
                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :label="$i18n.t('Admin Name') + '*'"
                      required
                      v-model="corporate.adminName"
                      :rules="validationrules.adminName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="2" lg="2">
                    <z-country-select
                      :label="$i18n.t('Country Code') + '*'"
                      required
                      isd
                      hideName
                      v-model="corporate.countryCodeAdmin"
                      :rules="validationrules.countryCodeAdmin"
                    ></z-country-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :label="$i18n.t('Phone') + '*'"
                      required
                      type="number"
                      v-model="corporate.phoneAdmin"
                      :rules="validationrules.phoneAdmin"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3" lg="4">
                    <v-text-field
                      :label="$i18n.t('Email') + '*'"
                      required
                      v-model="corporate.email"
                      :rules="validationrules.email"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <h4>{{ $i18n.t("Bank Account Detail") }}</h4>
                </v-row>
                <v-row>
                  <v-col ols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :label="$i18n.t('Account Name')"
                      dense
                      v-model="corpPOSO.bankAccount.holderName"
                    />
                  </v-col>
                  <v-col ols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :label="$i18n.t('Account Number')"
                      dense
                      v-model="corpPOSO.bankAccount.accountNo"
                    />
                  </v-col>
                  <v-col ols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :label="$i18n.t('Bank Name')"
                      dense
                      v-model="corpPOSO.bankAccount.bankName"
                    />
                  </v-col>
                  <v-col ols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :label="$i18n.t('IFSC Code')"
                      dense
                      v-model="corpPOSO.bankAccount.ifsc"
                    />
                  </v-col>
                  <v-col ols="12" sm="6" md="3" lg="3">
                    <v-text-field
                      :label="$i18n.t('Swift Code')"
                      dense
                      v-model="corpPOSO.bankAccount.swiftCode"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <small>*indicates required field</small>
              <v-spacer></v-spacer>
              <v-checkbox
                v-if="false"
                v-model="corporate.doNotNotify"
                :label="'Do Not Notify'"
              ></v-checkbox>
              <v-btn
                color="success darken-1"
                @click="save()"
                :loading="loading"
                :disabled="!isValid"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import CorpService from "@/store/common/module/CorpService";
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "VendorCreate",
  props: {
    label: {
      default: "Create Vendor",
    },
    singlePage: {
      default: null,
    },
  },
})
export default class VendorCreate extends Vue {
  isValid = true;
  corpPOSO = {
    _id: null,
    name: "",
    fullName: "",
    TANNo: "",
    GSTNo: "",
    PANNo: "",
    CINno: "",
    phoneAdmin: "",
    adminName: "",
    countryCodeAdmin: 91,
    email: "",
    doNotNotify: false,
    vendor: { name: null },
    bankAccount: {},
    address: { country: "India", state: "", city: "", addressLine: "" },
  };
  corporate = this.corpPOSO;
  path = "";
  leftColStyles = {};

  get loading() {
    return common.loading;
  }

  validationrules = {
    name: [(v) => !!v || this.$i18n.t("Name is required")],
    fullName: [(v) => !!v || this.$i18n.t("Full Name is required")],
    addressCountry: [(v) => !!v || this.$i18n.t("Country is required")],
    addressCity: [(v) => !!v || this.$i18n.t("City is required")],
    addressState: [(v) => !!v || this.$i18n.t("State is required")],
    addressAddressLine: [(v) => !!v || this.$i18n.t("Address is required")],
    adminName: [(v) => !!v || this.$i18n.t("Admin Name is required")],
    countryCodeAdmin: [
      (v) => !!v || this.$i18n.t("Admin Phone Code is required"),
    ],
    phoneAdmin: [
      (v) => !!v || this.$i18n.t("Admin Phone no is required"),
      (v) =>
        !isNaN(parseInt(v)) || this.$i18n.t("Admin Phone no should be valid"),
    ],
    email: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
  };

  closeDialog() {
    this.$emit("closeDialog", false);
  }

  async save() {
    try {
      common.setLoading(true);
      this.corporate = await doPost("/api/create/vendor", this.corporate);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      CorpService.clearVendors();

      if (this.singlePage) {
        this.$emit("select", {
          name: this.corporate.vendor.name,
          _id: this.corporate._id,
        });
        this.corporate = this.corpPOSO;
      } else {
        this.$router.push("/settings/vendor");
      }
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }
}
</script>
